import { render, staticRenderFns } from "./PosSessionDetails.vue?vue&type=template&id=0870969d&"
import script from "./PosSessionDetails.vue?vue&type=script&lang=js&"
export * from "./PosSessionDetails.vue?vue&type=script&lang=js&"
import style0 from "./PosSessionDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports